<script setup>
import { storeToRefs } from 'pinia';
import { computed, ref } from 'vue';
import { useSupportPlanEventStore } from '@/stores/supportPlanEvent';

const { searchSupportPlanEvents, createBlankEvent } = useSupportPlanEventStore();
const { supportPlanEvents } = storeToRefs(useSupportPlanEventStore());

import { trans } from 'laravel-vue-i18n';

const props = defineProps({
    supportPlan: {
        type: Object,
        default: () => null
    }
});

const params = ref({
    term: '',
    page: 1,
    per_page: 10,
});

const fetchSupportPlanEvents = () => {
    searchSupportPlanEvents({
        ...params.value,
        hash: props.supportPlan.hash,
    });
};

const tableUpdate = ({ page, sortBy, itemsPerPage }) => {
    Object.assign(params.value, { page, sort_by: sortBy, per_page: itemsPerPage });
    fetchSupportPlanEvents();
};

const createNewEvent = async () => {
    const payload = {
        support_plan_id: props.supportPlan.id,
    };
    const resp = await createBlankEvent(payload);

    const event = resp.data.event;

    window.location.href = `/clients/${props.supportPlan.client.hash}/support-plan/${props.supportPlan.hash}/events/${event.hash}`;
};

const gotoEvent = (item) => {
    window.location.href = `/clients/${props.supportPlan.client.hash}/support-plan/${props.supportPlan.hash}/events/${item.hash}`;
};

const eventHeaders = computed(() => [
    { title: trans('label.date'), key: 'date', value: item => `${item.date}` },
    { title: trans('label.block'), key: 'block', value: item => `${item.block}` },
    { title: trans('label.program'), key: 'program', value: item => `${item.program ? item.program.name : 'N/A'}` },
    { title: trans('label.highlight'), key: 'was_highlight', value: item => item.was_highlight ? trans('label.yes') : trans('label.no') },
]);
</script>

<template>
<div>
    <div class="flex justify-end pb-4">
        <StyledButton @click="createNewEvent()">
            <FontAwesomeIcon icon="plus" class="mr-1" />{{ $t('label.new_event') }}
        </StyledButton>
    </div>
    <DataTable
        v-if="supportPlanEvents && supportPlanEvents.data"
        :data="supportPlanEvents"
        :headers="eventHeaders"
        :actions="[
            {
                title: $t('label.edit'),
                icon: 'mdi-pencil',
                action: (item) => gotoEvent(item),
            }
        ]" 
        @table-update="tableUpdate" />
    <div v-else>
        {{ $t('label.no_support_plan_events') }}
    </div>
</div>
</template>
